<template>
  <div class="device-setting-preview-component" data-grm-comp="DeviceSettingPreview" :class="{ inRoom: !isDevicetest }">
    <div class="device-setting-preview">
      <div class="device-set-preview">
        <div class="device-set-preview-header" v-if="isMobile || !isDevicetest" :class="{screenSetting: !isDevicetest}">
          <div v-if="!isOpenDepsContainer" class="device-set-preview-title-wrapper">
            <a v-if="isDevicetest" :href="homeUrl" class="back-btn"></a>
            <button v-if="!isDevicetest" @click="onClose" class="close-btn"></button>
            <div v-if="isDevicetest">{{ roomTitle }}</div>
            <div v-else>{{ $t('camstudy.control.screenSetting') }}</div>
            <a href="https://webchat.thecloudgate.io/webChat?brandKey=MUxOPwt-6RJvxjfghABUmA&channelType=scenario&scenarioId=MzI3OQ" target="_blank" v-if="isDevicetest" class="ico-help-white"></a>
            <button v-else-if="!isDevicetest" class="save-content" @click="() => saveCoordi()">{{ $t('common.save') }}</button>
          </div>
          <div v-else-if="isOpenDepsContainer" class="device-set-preview-title-wrapper profile-modify">
            <div>{{ $t('camstudy.preview.profile.title') }}</div>
          </div>
        </div>
        <div class="device-set-preview-body">
          <div class="device-set-preview-video-container overflow-hidden">
            <div v-show="!isOpenDepsContainer" class="device-set-preview-video-wrapper relative overflow-hidden"
                 :class="[
                     { 'error': selectedDevice.video.state === 'error' }
                   ]">
              <!-- Canvas 기반 렌더링 (iOS 호환성) -->
              <div v-if="renderCanvas" ref="canvasRenderLayer" class="device-set-preview-video"
                   :class="{ mirror: selectedDevice.video.usePreviewMirror }"></div>
              <!-- 기본 비디오 엘리먼트 -->
              <video v-else autoplay muted webkit-playsinline playsinline class="device-set-preview-video bg-black previewVideo"
                     :class="{ mirror: selectedDevice.video.usePreviewMirror }"
                     ref="preview_video"></video>
              <div class="arrow-button" style="display: none"
                   ref="videoBlurControl" @pointerdown.prevent="onClickBlurFilterButton"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="30" height="30">
                  <!-- 위쪽 화살표 -->
                  <polygon points="50,10 35,25 65,25" fill="black"/>
                  <!-- 아래쪽 화살표 -->
                  <polygon points="50,90 35,75 65,75" fill="black"/>
                  <!-- 왼쪽 화살표 -->
                  <polygon points="10,50 25,35 25,65" fill="black"/>
                  <!-- 오른쪽 화살표 -->
                  <polygon points="90,50 75,35 75,65" fill="black"/>
                </svg>
              </div>
              <div
                  class="v-bg"
                  :class="{'no-cam': cameraOff }"
              >
                <img class="pointer-events-none"
                     v-show="cameraOff"
                     :style="{
                        width: '96px',
                        height: '96px',
                        objectFit: 'cover',
                        borderRadius: '50%'
                     }"
                     :src="getUserImage"
                />
              </div>
              <div ref="canvas-setting-ref"></div>
              <div v-show="!blurVideo.isOpen">
                <div class="determination-message" @click="onOpenDetermination">{{ myMsg || $t('camstudy.preview.determination.enter') }}</div>
                <div class="video-preview-stopwatch" :style="getStopWatchStyle">00:00:00</div>
              </div>
              <div class="device-container shadow-rectangle" v-show="!blurVideo.isOpen">
                <div class="device-info-container">
                  <div :class="{active: isCameraStatus('on') , inactive: isCameraStatus('off'), notExist: isCameraStatus('notExist')}"
                       class="device-info-image camera" @click="onToggleUserDeviceStatus"></div>
                  <div class="device-info-message">{{ $t('common.device.camera') }}</div>
                </div>
                <div class="device-info-container" v-if="isMobile">
                  <div class="device-info-image transition"
                       @click="toggleCamera"
                  ></div>
                  <div class="device-info-message">{{ $t('camstudy.preview.switch') }}</div>
                </div>
<!--                <div class="device-info-container">-->
<!--                  <div class="device-info-image blurVideo"-->
<!--                       @click="toggleBlurVideo"-->
<!--                  ></div>-->
<!--                  <div class="device-info-message">{{ $t('camstudy.preview.videoBlur.title') }}</div>-->
<!--                </div>-->
                <div class="device-info-container">
                  <div class="relative" @click="onOpenDepsContainer">
                    <img v-if="userProfile.profileImageUrl" class="device-info-image" :src="userProfile.profileImageUrl" />
                    <div v-else class="user-image-none"></div>
                    <div class="modify-profile"></div>
                  </div>
                  <div ref="device-info-nickname" class="device-info-message">{{ userProfile.nickname }}</div>
                </div>
              </div>
              <transition name="fade">
                <GrmLoadingCircle v-if="selectedDevice.video.state === 'loading'"
                                  class="rounded-lg bg-black bg-opacity-50 absolute inset-0"
                />
              </transition>
            </div>
            <div v-if="inProgressUpload" class="device-set-preview-video-wrapper profile-modify relative">
              <div class="loading-spinner"></div>
            </div>
            <div v-else-if="isOpenDepsContainer && !isShowCropper" class="device-set-preview-video-wrapper profile-modify justify-center relative">
              <div class="image-profile-container relative" @click="onOpenImageSelect">
                <img v-if="editUserProfile.profileImageUrl" class="profile-image" :src="editUserProfile.profileImageUrl" alt=""/>
                <div v-else class="user-image-none profile-image-none"></div>
                <div class="modify-profile-image"></div>
              </div>
              <div class="profile-modify-input-container">
                <div class="profile-name-temp"></div>
                <input type="text" class="profile-name-input" v-model="editUserProfile.nickname">
                <div class="profile-name-change-icon"></div>
              </div>
              <div class="flex gap-2.5 w-full profile-button-container">
                <button class="profile-button cancel" @click="onCloseDepsContainer">{{ $t('common.cancel') }}</button>
                <button :disabled="isLoadingChangeUserProfile" class="profile-button save" @click="onSaveUserProfile">{{ $t('common.save') }}</button>
              </div>
            </div>
            <div v-else-if="isOpenDepsContainer && isShowCropper" class="device-set-preview-video-wrapper profile-modify flex-start relative">
              <div class="cropper-container">
                <cropper :src="selectedImage?.path"
                         class="cropper"
                         :options="{ aspectRatio: 338 / 273 }"
                         :stencil-props="{ aspectRatio: 1 }"
                         @change="onChangeCropImage"
                />
              </div>
              <div class="flex gap-2.5 w-full profile-button-container">
                <button class="profile-button cancel" @click="onCancelCropImage">{{ $t('common.cancel') }}</button>
                <button class="profile-button save" @click="onCompleteCropImage">{{ $t('common.complete') }}</button>
              </div>
            </div>
            <!--      blur      -->
<!--            <div v-show="blurVideo.isOpen" class="blur-video-container">-->
<!--              <div class="blur-weight">-->
<!--                <div class="blur-weight-progress-container">-->
<!--                  <div class="progress-title">{{ $t('camstudy.preview.videoBlur.intensity') }}</div>-->
<!--                  <input type="range" min="0" :max="blurVideo.blurMaxSize" class="custom-slider"-->
<!--                         v-model="blurVideo.blurSize" @input="setBlurVideo" :style="{'&#45;&#45;slider-progress': `${(blurVideo.blurSize / blurVideo.blurMaxSize) * 100}%`}" />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="blur-height">-->
<!--                <div class="blur-weight-progress-container vertical">-->
<!--                  <div class="progress-title">{{ $t('camstudy.preview.videoBlur.height') }}</div>-->
<!--                  <input type="range" min="0" max="100" class="custom-slider"-->
<!--                         v-model="blurVideo.height" @input="setBlurVideo" :style="{'&#45;&#45;slider-progress': `${blurVideo.height}%`}" />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="flex gap-2.5 w-full blur-button-container">-->
<!--                <button class="blur-video-button cancel" style="display: none;" @click="cancelBlurVideo">{{ $t('common.cancel') }}</button>-->
<!--                <button class="blur-video-button save" @click="saveBlurVideo">{{ $t('common.complete') }}</button>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="setting-container">
            <div class="coordi-options-container">
              <button v-if="isDevicetest" @click="changeCoordiComponent" value="roomInfo" :class="{isActive: coordiComponent === 'roomInfo'}">{{ $t('camstudy.preview.options.info') }}</button>
              <button @click="changeCoordiComponent" value="sticker" :class="{isActive: coordiComponent === 'sticker'}">{{ $t('camstudy.preview.options.sticker') }}</button>
              <button @click="changeCoordiComponent" value="stopWatch" :class="{isActive: coordiComponent === 'stopWatch'}">{{ $t('camstudy.preview.options.stopwatch') }}</button>
              <button @click="changeCoordiComponent" value="CameraScreenSetting" :class="{isActive: coordiComponent === 'CameraScreenSetting'}">{{ $t('camstudy.preview.options.cameraSetting') }}</button>
              <button v-if="!isMobile" @click="changeCoordiComponent" value="DeviceSetting" :class="{isActive: coordiComponent === 'DeviceSetting'}">{{ $t('camstudy.preview.options.deviceSetting') }}</button>
            </div>

            <component
                :is="coordiComponent"
                v-show="coordiComponent"
                :room-info="roomInfo"
                :camStudyRoomInfoProps="camStudyRoomInfoProps"
                :isDevicetest="isDevicetest"
                :userProfile="userProfile"
                :isOpenDeps="isOpenDeps"
                @saveCoordi="saveCoordi"
                @onChangeStopWatchImage="onChangeStopWatchImage"
                @toggleTransitionCamera="toggleTransitionCamera"
                @onOpenDeps="onOpenDeps"
            />

            <button
              v-if="isOpenDeps && coordiComponent === 'CameraScreenSetting'"
              class="default-btn-previous join-request-btn join-room-btn"
              :class="{innerRoom: !isDevicetest}"
              @click="onCloseDeps"
            >{{ $t('common.prev') }}</button>
            <button v-else-if="isDevicetest" class="default-btn join-request-btn join-room-btn"
                    @click="join"
            >{{ joinText }}</button>
          </div>
        </div>
      </div>
      <div v-if="isOpenDetermination" class="determination-input-container" :class="{isDeviceTest}">
        <div class="determination-body">
          <h4 class="determination-title">{{ $t('camstudy.preview.determination.title') }}</h4>
          <input type="text" :value="myMsg" class="determination-input" ref="myMsgInput"/>
        </div>
        <div class="determination-footer">
          <button class="determination-button cancel" @click="onCloseDetermination">{{ $t('common.cancel') }}</button>
          <button class="determination-button ok" @click="onCheckDetermination">{{ $t('common.confirm') }}</button>
        </div>
      </div>
    </div>
    <div v-if="isOpenImageSelect" class="image-select-cover" @click="onCloseImageSelect">
      <div class="image-select-container" @click.stop>
        <button class="image-select-button relative" @click="onChangeFileData">
          {{ $t('camstudy.preview.profile.image.select') }}
        </button>
        <button class="image-select-button" @click="onChangeDefaultProfileImage">{{ $t('camstudy.preview.profile.image.default') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";

import "@/lib/gooroomee/webrtc/GrmWebRTC.adapter";
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";
import "@/lib/gooroomee/canvas/coordiCanvas/gooroomee-canvas-0.0.3"

import {Device} from "@/utils";

import _ from "lodash";
import DetectRTC from "detectrtc";

import GrmLoadingCircle from "@/components/Common/loading/GrmLoadingCircle";
import DeviceSettingAudioTest from '@/components/Room/DeviceSetting/AudioTest'
import DeviceSetting from "@/components/Room/DeviceSetting/coordi/DeviceSetting.vue"
import Sticker from "@/components/Room/DeviceSetting/coordi/Sticker.vue"
import RoomInfo from "@/components/Room/DeviceSetting/coordi/RoomInfo.vue"
import StopWatch from "@/components/Room/DeviceSetting/coordi/StopWatch.vue"
import CameraScreenSetting from "@/components/Room/DeviceSetting/coordi/CameraScreenSetting.vue";
import {stickerImageUrl} from "@/utils/stickerImage";
import {cdnImgUrl, parseImagePath} from "@/utils/ImageUrl";
import VideoPauseMixin from "@/components/Room/Camstudy/mixins/VideoPauseMixin.vue";
import {Cropper} from "vue-advanced-cropper";
import {getCamStudyV2HomeUrl} from '@/utils/CamStudyV2Helper'

import {} from "@/core/api/camstudy/room.camstudy.personal.api"
/**
 * @todo
 * 화면설정에서 UI 안맞음
 **/
export default {
  name: 'CamstudyPreview',
  mixins: [VideoPauseMixin],
  components: {
    Cropper,
    GrmLoadingCircle,
    // GrmCloseBtn,
    DeviceSettingAudioTest,
    DeviceSetting,
    Sticker,
    RoomInfo,
    StopWatch,
    CameraScreenSetting
  },
  props: {
    roomInfo: Object,
    isShowCoachmark: Boolean,
    isDevicetest: Boolean,
  },
  data() {
    return {
      Device,
      selectedTab: 'video',
      isShowAudioTest: false,
      renderCanvas: null, // Canvas 기반 렌더링용
      currentGrmTrack: null, // 현재 GrmTrack 저장용
      selectedDevice: {
        video: {
          showModal: false,
          state: 'ready', // loading, success, error
          deviceId: null,
          label: '',
          virtualBackgroundType: 'none',
          virtualBackgroundUrl: '',
          stream: null,
          proStream: null,
          usePreviewMirror: true,
        },
        audio: {
          showModal: false,
          state: 'ready',
          deviceId: null,
          label: '',
          volume: 0,
          stream: null,
          proStream: null,
        },
        audiooutput: {
          showModal: false,
          state: 'ready',
          deviceId: null,
          label: '',
          volume: 0,
          isPaused: true
        },
        cameraStatus: '',
      },
      coordiComponent: '',

      purchasedStickerList: [],
      isResizeCanvas: false,
      userProfile: {
        nickname: '',
        profileImageUrl: '',
        profileImagePath: '',
        userId: '',
      },
      editUserProfile: {
        nickname: '',
        profileImageUrl: '',
        originProfileImagePath: '',
        removeImage: false,
        file: null
      },
      homeUrl: '',
      roomTitle: '',
      selectedStopwatchType: 'basic',
      selectedStopwatchSubType: 'default',
      isOpenDetermination: false,
      camStudyRoomInfoProps: null,
      myMsg: '',
      stickerList: [],
      isOpenDepsContainer: false,
      isOpenImageSelect: false,
      isShowCropper: false,
      selectedImage: {
        file: null,
        path: null
      },
      cropImage: {
        file: null,
        path: null
      },
      editImage: {

      },
      allowedFileExtensions: ['jpg', 'jpeg', 'png', 'gif'],
      inProgressUpload: false,
      isLoadingChangeUserProfile: false,
      blurVideo: {
        isOpen: false,
        height: 0,
        blurSize: 0,
        blurMaxSize: 10
      },
      isBlurEnabled: true,
      isOpenDeps: false,
    }
  },
  async created() {
    const mobile = Device.isMobile();
    if (mobile) {
      this.homeUrl = getCamStudyV2HomeUrl()
    } else {
      this.homeUrl = 'service/room'
    }

    this.initVideoPreview();
    // if (this.deviceSettings) {
    //   ['video', 'audio', 'audiooutput'].forEach(device => {
    //     if (this.deviceSettings[device]) {
    //       this.selectedDevice[device] = Object.assign({}, this.selectedDevice[device], this.deviceSettings[device]);
    //     }
    //   })
    //   this.selectedDevice.cameraStatus = this.deviceSettings.cameraStatus
    // }

    let camStudyRoomInfo = await this.getCamStudyRoomInfo(this.roomInfo?.roomId || this.camStudy.roomId);
    const roomInfo = camStudyRoomInfo.room;
    const camStudyInfo = camStudyRoomInfo.camStudy;

    this.roomTitle = roomInfo.title || camStudyInfo.studyTitle;
    this.camStudyRoomInfoProps = camStudyRoomInfo
    this.coordiComponent = this.isDevicetest ? 'roomInfo' : 'sticker';

    if(this.isDevicetest) {
      await this.initPreviewCoordi();
    } else {
      await this.initRoomCoordi();
    }

    this.isBlurEnabled = this.isUserTrialEnabledBy('BLUR')
    if (!this.isBlurEnabled) {
      this.clearBlurVideo()
    }
  },
  async mounted() {
    const THIS = this;
    let windowWidth = window.innerWidth
    window.addEventListener('resize', function() {
      if (window.innerWidth !== windowWidth) {
        THIS.isResizeCanvas = true;
        THIS.initCanvas({reset: true});
        windowWidth = window.innerWidth
      }
    });

    THIS.isResizeCanvas = false;
    if(this.$refs['device-info-nickname']){
      this.$refs['device-info-nickname'].style.transform = `translateX(-${(this.$refs['device-info-nickname'].clientWidth - 48)/2}px)`;
      this.$refs['device-info-nickname'].style.position = `absolute`;
    }

    this.initCanvas();
  },
  async beforeDestroy() {
    await this.stopMediaStream();
  },
  computed: {
    ...mapState('waitingRoom', [
      'enabled',
      'roomClosed',
      'disapproved',
      'enterRequested',
      'noManagerInRoom',
      'deviceRequired'
    ]),
    ...mapGetters('room', [
      'devices',
      'deviceSettings',
      'roomInfoSetting',
      'noiseCancelAvailable',
    ]),
    ...mapGetters('coordi', ['userStickerList']),
    ...mapGetters('user', [
      'me',
    ]),
    ...mapGetters('camstudy', [
      'camStudy',
      'getCamStudyUser',
      'isUserTrialEnabledBy',
      'personalSetting'
    ]),
    myStickerList() {
      return this.userStickerList(this.me?.userId || this.userProfile?.userId)
    },
    getNecessarySettings(){
      let selected_devices = this.selectedDevice;
      return _.merge({}, {
        video: {
          deviceId: (() => {
            const track = this.getPreviewVideoTrack();
            return track?.GrmTrack?.getDeviceId();
          })(),
        },
        cameraStatus: selected_devices.cameraStatus
      })
    },
    isIOS() {
      return Device.isIOS();
    },
    isSafari() {
      return Device.isSafari();
    },
    isMobile(){
      return Device.isMobile();
    },
    joinText() {
      return this.enabled
          ? this.disapproved || this.noManagerInRoom || this.roomClosed
              ? this.$t('deviceSetting.preview.toHome')
              : this.enterRequested
                  ? this.$t('deviceSetting.preview.join.requested')
                  : this.$t('deviceSetting.preview.join.request')
          : this.$t('deviceSetting.preview.join.title');
    },
    isVirtualBgAvailable() {
      return this.roomInfoSetting?.useVirtualBg !== false && !this.isIOS && !this.isSafari;
      // return this.roomInfoSetting?.useVirtualBg !== false;
    },
    // virtualBgAvailableText() {
    //   if(!this.roomInfoSetting?.useVirtualBg !== false){
    //     return this.$t('deviceSetting.preview.virtualBackground.notActivated');
    //   }else if(this.isIOS || this.isSafari){
    //     return this.$t('deviceSetting.preview.virtualBackground.notSupport');
    //   }else {
    //     return 'UNKNOWN';
    //   }
    // },
    getStopWatchStyle(){
      if(this.selectedStopwatchType === 'cash-item-01'){
        return {backgroundImage: `url("${require(`@/assets/images/camstudy/stopwatch_background_image${this.selectedStopwatchSubType}.svg`)}")`, backgroundSize: '84px 28px', top: '-2px', right: 0};
      }
      return {background: this.selectedStopwatchSubType === 'default' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 90, 180, 0.70)'};
    },
    getUserImage(){
      return this.userProfile.profileImageUrl || require('@/assets/images/user_profile.svg')
    },
    cameraOff() {
      return this.isCameraStatus('off')
    },
    isCameraStatus() {
      return (status) => {
        if(this.isDevicetest) {
          const cs = this.selectedDevice['cameraStatus']
          return cs === status || status === 'on'
        } else {
          return this.me.cameraStatus === status ||
          (status === 'notExist' && this.me.cameraStatus === undefined)
        }
      }
    },
  },
  methods: {
    ...mapMutations('room',[
      'SET_DEVICES',
    ]),
    ...mapMutations('waitingRoom',[
      'ENTER_REQUESTED',
    ]),
    ...mapActions('room',[
      'saveDeviceSettings'
    ]),
    ...mapActions('coordi', [
      'getUserStickerList',
      'setUserSticker'
    ]),
    ...mapActions('camstudy', [
        'getCamStudyUserProfile',
        'getCamStudyRoomInfo',
        'saveUserStopWatchSetting',
        'modifyCamStudyMyMsg',
        'getCamStudyMyMsg',
        'getCamStudyUserStopWatchSetting',
        'changeCamStudyUserNickname',
        'getPersonalSetting'
    ]),
    ...mapActions('user', [
      'toggleUserDeviceStatus',
      'uploadProfileImageFile',
      'changeProfileImage',
    ]),
    onOpenDeps(){
      this.isOpenDeps = true;
    },
    onCloseDeps(){
      this.isOpenDeps = false;
    },
    async initPreviewCoordi() {
      // user profile
      const userProfile = await this.getCamStudyUserProfile({ roomId: this.roomInfo?.roomId || this.camStudy.roomId });
      const initUserProfile = {
        nickname: userProfile.nickname || userProfile.username,
        profileImageUrl: userProfile?.profileImagePath ? cdnImgUrl(userProfile?.profileImagePath) : '',
        profileImagePath: userProfile?.profileImagePath || '',
        userId: userProfile.userId
      }
      Object.assign(this.userProfile, initUserProfile);

      // user myMsg
      this.myMsg = await this.getCamStudyMyMsg({
        roomId: this.roomInfo?.roomId || this.camStudy.roomId,
        userId: userProfile.userId
      });

      // user stopWatch setting
      const userStopWatchInfo = await this.getCamStudyUserStopWatchSetting({
        roomId: this.roomInfo?.roomId || this.camStudy.roomId,
        userId: userProfile.userId
      });
      this.selectedStopwatchType = userStopWatchInfo.userItemSetting?.selectedStopwatchType || 'basic';
      this.selectedStopwatchSubType = userStopWatchInfo.userItemSetting?.selectedStopwatchSubType || 'default';

      // user sticker list
      await this.getUserStickerList({
        roomId: this.roomInfo?.roomId || this.camStudy.roomId,
        userId: userProfile.userId
      })
    },
    async initRoomCoordi() {
      const camStudyUser = await this.getCamStudyUser(this.me.userId);
      this.userProfile = {
        nickname: camStudyUser.username,
        profileImageUrl: camStudyUser.profileImageUrl,
        profileImagePath: camStudyUser.profileImageUrl ? parseImagePath(camStudyUser.profileImageUrl) : '',
        userId: this.me.userId
      }
      const userStopSetting = camStudyUser?.camStudyUserItemSettingList?.[0]?.itemSetting;
      this.selectedStopwatchType = userStopSetting?.selectedStopwatchType || 'basic';
      this.selectedStopwatchSubType = userStopSetting?.selectedStopwatchSubType || 'default';
      this.myMsg = camStudyUser?.myMsg || '';
    },
    initCanvas(initOptions) {
      const canvas = this.$refs['canvas-setting-ref'];
      if (!canvas) return;

      if(this.grmCvs && (!initOptions || !initOptions.reset)){
        console.warn('grmCvs init already');
        return;
      }

      const video = this.$refs['preview_video']
      let isVideoMode = false;
      if(video) {
        isVideoMode = true;
      }
      const baseEl = video || this.$refs.canvasRenderLayer;

      if(isVideoMode) {
        // iOS/Safari에서는 Canvas 렌더링 모드로 동작하여 video playing 이벤트가 발생하지 않음
        if (video.paused && !(this.isIOS || this.isSafari)) {
          video.addEventListener('playing', async (e) => {
            this.initCanvas();
            await this.getPersonalSetting();
            const track = this.getPreviewVideoTrack();
            const isFaceMaskEnabled = this.isUserTrialEnabledBy('FACE_MASK')
            if(isFaceMaskEnabled) {
              const trackApp = track?._grm_tg;
              if (!trackApp) return;
              if (this.personalSetting.coverFace === 'off') {
                trackApp.setFaceDrawType(null);
              } else {
                const faceImage = require(`@/assets/roomType/lms/img/emoti-img/grm-face-01.svg`);
                await trackApp.pipeThrough('FaceDetector', {
                  drawType: 'faceImage',
                  faceImage,
                });
                await trackApp.setFaceImage(faceImage);
              }
            }
          }, {once: true});
          return;
        }
      }
      // iOS/Safari에서는 Canvas 렌더링 모드이므로 Face detection을 나중에 초기화
      // (track이 설정된 후 setupCanvasRender에서 처리)

      Object.assign(canvas.style, {
        position: 'absolute',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%'
      });
      setTimeout(() => {
        // const video = this.$refs['preview_video'];
        const isPortrait = Device.portrait() && (isVideoMode ? baseEl.clientHeight : baseEl.clientHeight) >= 234 && (Device.isMobile() || Device.isTablet())
        if (isPortrait) {
          baseEl.classList.add(Device.isMobile() ? 'mobile-portrait' : 'portrait');
          // videoWrapper.classList.add(Device.isMobile() ? 'mobile-portrait' : 'portrait');
          // roomCordiDialog && roomCordiDialog.classList.add(!Device.isMobile() && 'portrait');
        } else {
          baseEl.classList.remove(Device.isMobile() ? 'mobile-portrait' : 'portrait');
          // videoWrapper.classList.remove(device.mobile() ? 'mobile-portrait' : 'portrait');
          // roomCordiDialog && roomCordiDialog.classList.remove('portrait');
        }
        if (!baseEl || !(isVideoMode ? baseEl.videoWidth : baseEl.clientWidth) ) {
          return;
        }
        let rect = canvas.getBoundingClientRect();

        let ratioX = rect.width / (isVideoMode ? baseEl.videoWidth : baseEl.clientWidth)
        let ratioY = rect.height / (isVideoMode ? baseEl.videoHeight : baseEl.clientHeight);
        let ratio = Math.min(ratioX, ratioY);

        let videoWidth = (isVideoMode ? baseEl.videoWidth : baseEl.clientWidth) * ratio;
        let videoHeight = (isVideoMode ? baseEl.videoHeight : baseEl.clientHeight) * ratio;
        let style = {
          width: isPortrait ? '100%' : videoWidth + 'px',
          height: isPortrait ? '100%' : videoWidth + 'px'
        };
        if (ratioX > ratioY) {
          style.left = isPortrait ? 0 : (
              parseFloat(canvas.style.left)
              + ((rect.width - videoWidth) / 2)
          ) + 'px';
        } else {
          style.top = 0
        }
        Object.assign(canvas.style, style);
        if (!this.grmCvs) {
          let options = {
            bgColor: 'transparent',
            useWheel: false,
            useToolkitDefaultMouseButton: false,
            forceAspectRatioSize: true,
            useContextMenu: true,
            autoResizeDetection: true,
            contextMenuContainer: document.body,
            useCopyAndPasteOption: false,
            excludeContextMenu: ['copy', 'copy_paste', 'paste']
          };
          this.grmCvs = new window.GooroomeeCanvas(canvas, options);
          this.grmCvs.clear();
          this.grmCvs.changeToolkit('select');

          this.grmCvs.on('addElement removeElement addLink transform arrange', e => {
            this.editSticker = true;
          })

          this.orientationchange = () => {
            this.initCanvas({reset: true});
          };
          window.addEventListener('orientationchange', this.orientationchange);
        }
        if (this.myStickerList && !initOptions || this.myStickerList && initOptions && !initOptions.reset) {
          this.grmCvs.clear();
          this.myStickerList.forEach(data => {
            this.addStickerData(data);
          })
        }
      }, 100)

      setTimeout(()=>{
        this.showSticker();
      },300)
    },
    async selectSticker(sticker) {
      let el = this.grmCvs.elements.canvas.querySelector(`[data-grm-stickerid="${sticker.id}"]`);
      if( el ){
        console.warn('sticker existed already :', el);
        return;
      }

      let url = await stickerImageUrl(sticker);
      this.grmCvs.addImage(url, {adjustSizeRatio: 0.2})
          .then(data => {
            console.log('add sticker :', data);
            data.el.setAttribute('data-grm-stickerid', sticker.id);
            data.el.setAttribute('data-grm-imgpath', sticker.imagePath);
            data.el.setAttribute('data-grm-oriwidth', data.oriWidth);
            data.el.setAttribute('data-grm-oriheight', data.oriHeight);
          });
    },
    async addStickerData(sData) {
      if(!sData) return;
      if(Array.isArray(sData)){
        sData.forEach(data => {
          this.addStickerData(data);
        });
        return;
      }

      let url = await stickerImageUrl(sData);
      return this.grmCvs.addImage(url)
          .then(data => {
            let setting = sData.setting;
            let ratio = 1, ratioX = 1, ratioY = 1;
            if(setting.editor.canvasSize){
              let rect = this.grmCvs.target.getBoundingClientRect();
              ratioX = rect.width / setting.editor.canvasSize[0] * this.grmCvs.zoom();
              ratioY = rect.height / setting.editor.canvasSize[1] * this.grmCvs.zoom();
              ratio = Math.min(ratioX, ratioY);
            }

            data.el.querySelector('image').setAttribute('transform', setting.editor.svgImageTransform);
            data.el.style.cssText = setting.editor.style;

            if(ratioX != 1 || ratioY != 1){
              // eslint-disable-next-line no-inner-declarations
              function set(keys, ratio){
                keys.forEach(key => {
                  let val = parseInt(data.el.style[key]) * ratio;
                  if(!isNaN(val)){
                    data.el.style[key] = val + 'px';
                  }
                });
              }
              set(['left', 'top', 'width', 'height'], ratio);
            }

            data.el.setAttribute('data-grm-stickerid', sData.stickerId);
            data.el.setAttribute('data-grm-imgpath', sData.imagePath);
            data.el.setAttribute('data-grm-oriwidth', data.oriWidth);
            data.el.setAttribute('data-grm-oriheight', data.oriHeight);
            data.el.style['display'] = 'none';
            return data;
          });
    },
    showSticker(){
      const canvas = this.$refs['canvas-setting-ref'];
      const stickerNodeList = canvas.querySelectorAll(`[data-grm-stickerid]`);
      if (stickerNodeList && stickerNodeList.length) {
        stickerNodeList.forEach(sticker => {
          sticker.style['display'] = 'block';
        })
      }
    },
    resetUserSticker() {
      const canvas = this.grmCvs.elements.canvas;
      const stickerNodeList = canvas.querySelectorAll(`[data-grm-stickerid]`);
      if (stickerNodeList && stickerNodeList.length) {
        stickerNodeList.forEach(sticker => sticker.remove());
      }
      this.isMoreModalOpen = false;
    },
    changeCoordiComponent(e){
      if(this.coordiComponent === e.target.value){
        return;
      }
      this.isOpenDeps = false;
      this.coordiComponent = e.target.value
    },
    async deviceTestComplete() {
      return new Promise((resolve, reject) => {
        DetectRTC.load(() => {
          const cameraPermission = DetectRTC.isWebsiteHasWebcamPermissions;
          const micPermission = DetectRTC.isWebsiteHasMicrophonePermissions;

          if(
              cameraPermission
              // && micPermission
          ){
            console.log('has device permission')
            resolve();
            return;
          }

          let text = '';
          let okText = '';

          if(this.enabled && this.deviceRequired){
            if(!cameraPermission || !micPermission){
              this.$camsAlert({
                title: this.$t('common.alert.title'),
                text: this.$t('deviceSetting.essential'),
                class: 'device-authority',
                imgSrc: require('@/assets/roomType/lms/img/img-device-authority.png'),
                onlyOk: true
              });
              this.ENTER_REQUESTED(false)
            }
          }else{
            const n_has = [], n_perm = [];
            const msg = [];
            if(DetectRTC.videoInputDevices.length == 0){
              n_has.push(this.$t('common.device.camera'));
            }else if(!DetectRTC.isWebsiteHasWebcamPermissions){
              n_perm.push(this.$t('common.device.camera'));
            }

            if(n_has.length > 0){
              msg.push(
                  this.$t('deviceSetting.preview.device.notConnected', { '0' : n_has.join(', ') })
              );
            }
            if(n_perm.length > 0){
              msg.push(
                  this.$t('deviceSetting.preview.device.noRole', { '0' : n_perm.join(', ') })
              );
            }
            if(msg.length > 0){
              text = msg.join('<br>');
              okText = this.$t('deviceSetting.preview.device.without', { '0' : n_has.concat(n_perm).join(', ') });
            }
            this.$camsAlert({
              title: this.$t('deviceSetting.preview.device.check'),
              text: text,
              class: 'device-authority',
              imgSrc: require('@/assets/images/camstudy/not_devcie_alert_image.png'),
              okText: okText,
              ok: resolve
            });
          }
        });
      });
    },
    onClose() {
      if(!this.isDevicetest){
        this.$modal('CamstudyDeviceSettingModal')
      }
    },
    // keymap(e) {
    // switch (e.keyCode) {
    //   case 13:
    //     this.applyChangedDevice()
    //     break
    //   case 27:
    //     this.closeModal()
    //     break
    // }
    // },
    parseStickerData() {
      if(!this.grmCvs){
        return [];
      }
      let videoRect = this.grmCvs.elements.canvas.getBoundingClientRect();
      const THIS = this;

      let els = this.grmCvs.findDrawElementsBySelector('[data-g][data-toolkit="image"]');
      let stickerList = Array.prototype.map.call(els, el => {
        let stickerId = el.getAttribute('data-grm-stickerid');
        let imagePath = el.getAttribute('data-grm-imgpath');
        let rect = el.querySelector('image').getBoundingClientRect();
        let left = rect.x - videoRect.x;
        let top = rect.y - videoRect.y;
        left = parseFloat(((left / videoRect.width) * 100).toFixed(2)) + '%';
        top = parseFloat(((top / videoRect.height) * 100).toFixed(2)) + '%';

        let width = parseFloat(((rect.width / videoRect.width) * 100).toFixed(2)) + '%';
        let height = parseFloat(((rect.height / videoRect.height) * 100).toFixed(2)) + '%';

        let transform = el.style.transform;

        return {
          roomId: THIS.roomInfo?.roomId || this.camStudy.roomId,
          userId: THIS.me.userId,
          stickerId,
          imagePath,
          setting: JSON.stringify({
            style: {
              left, top,
              width, height,
              transform
            },
            editor: {
              canvasSize: [videoRect.width, videoRect.height],
              style: el.style.cssText,
              svgImageTransform: el.querySelector('image').getAttribute('transform')
            }
          })
        };
      });

      return stickerList;
    },
    async join() {
      // await this.saveCoordi();
      this.stickerList = this.parseStickerData();
      if (this.enabled) {
        this.$emit('reqApproveJoin');
      } else {
        this.$emit('reqJoin', this.saveCoordi);
      }
    },
    async saveCoordi(type){
      try {
        if (!type) {
          await this.saveSticker();
          await this.saveStopWatch();
          await this.modifyMyMsg();
          await this.saveVideoDevice();
        } else if (type === 'sticker') {
          await this.saveSticker();
        } else if (type === 'stopwatch') {
          await this.saveStopWatch();
        }
        if(!this.isDevicetest){
          this.$camsAlert({
            title: this.$t('common.save'),
            text: this.$t('common.saveText'),
            onlyOk: true
          })
          this.onClose();
        }
      }catch(err) {
        console.warn("coordi err ", err)
      }
    },
    async saveSticker() {
      if(!this.isDevicetest){
        this.stickerList = this.parseStickerData();
      }
      try{
        await this.setUserSticker({
          roomId: this.roomInfo?.roomId || this.camStudy.roomId,
          userId: this.me.userId,
          stickers: this.stickerList
        });
      }catch(e){
        // 임시. 최초 입장 시 camstudy user data 가 없어 저장 오류 발생. 입장 시키고 data 가 생긴 이후 저장 로직이 호출 되어야함.
        if(this.stickerList.length === 0) return;
        throw e;
      }
    },
    async saveStopWatch() {
      const roomId = this.roomInfo?.roomId || this.camStudy.roomId
      await this.saveUserStopWatchSetting({
        roomId,
        sendEvent: !this.isDevicetest,
        data: {
          pomodoroData: {
            focusTime: '25',
            isFocusOfNoti: false,
            relaxTime: '5',
            isRelaxOfNoti: false
          },
          selectedStopwatchSubType: this.selectedStopwatchSubType,
          selectedStopwatchType: this.selectedStopwatchType,
        }
      });
    },
    async modifyMyMsg() {
      const roomId = this.roomInfo?.roomId || this.camStudy.roomId
      await this.modifyCamStudyMyMsg({
        roomId,
        myMsg: this.myMsg
      });
    },
    onChangeStopWatchImage(data){
      this.selectedStopwatchType = data.type;
      this.selectedStopwatchSubType = data.subType;
    },
    onOpenDetermination(){
      this.isOpenDetermination = true;
    },
    onCloseDetermination() {
      this.isOpenDetermination = false;
    },
    async onCheckDetermination(){
      if(this.myMsg === this.$refs.myMsgInput.value) {
        return;
      }

      this.myMsg = this.$refs.myMsgInput.value;
      if(!this.isDevicetest) {
        await this.modifyMyMsg();
      }
      this.isOpenDetermination = false;
    },
    isEnableDevice(){
      return (deviceType) => {
        if(!deviceType) return;

        const {roomUserRole} = this.me;
        if(!roomUserRole) return;

        return roomUserRole[deviceType];
      }
    },
    onToggleUserDeviceStatus(){
      if(!this.isEnableDevice('camera')){
        return
      }
      if(this.isDevicetest) {
        this.selectedDevice.cameraStatus = this.cameraOff ? 'on' : 'off'
      } else {
        this.toggleUserDeviceStatus({deviceType: 'camera'})
      }
    },
    onCloseDepsContainer(){
      this.cleanUpEditUserProfile();
      this.isOpenDepsContainer = false;
    },
    onOpenDepsContainer(){
      Object.assign(this.editUserProfile, {
        nickname: this.userProfile.nickname,
        profileImageUrl: this.userProfile.profileImageUrl,
        originProfileImagePath: this.userProfile.profileImagePath,
        file: null,
        removeImage: false
      })
      this.isOpenDepsContainer = true;
    },
    onOpenImageSelect(){
      this.isOpenImageSelect = true;
    },
    onCloseImageSelect(){
      this.isOpenImageSelect = false;
    },
    // file select method st

    onChangeDefaultProfileImage() {
      this.editUserProfile.profileImageUrl = ''
      if (this.editUserProfile.originProfileImagePath) {
        this.editUserProfile.removeImage = true
      }
      this.editUserProfile.file = null
      this.onCloseImageSelect()
    },
    async onChangeFileData(){
      if (this.inProgressUpload) {
        return
      }

      try {
        this.inProgressUpload = true
        const files = await this.getFileChooser({
          multiple: false,
          accept: this.allowedFileExtensions.join(","),
          size: 1
        })

        if (files && files.length > 0) {
          const file = files[0]
          if (!this.validExtension(file)) {
            this.$camsAlert(this.$t('camstudy.preview.profile.image.fileTypeError'))
            return
          }
          // max 100kb
          const compressedImage = await this.compressImage(file, 100 * 1024)
          this.resetSelectedImage()
          this.resetCropImage()
          this.selectedImage.file = compressedImage
          this.selectedImage.path = URL.createObjectURL(compressedImage)
          this.isShowCropper = true
        }
      } catch (e) {
        console.warn('## onChangeFileData warn -> reason[%s]', e)
      } finally {
        this.inProgressUpload = false
      }
      this.onCloseImageSelect()
    },
    validExtension(file) {
      const fileNameArr = file.name.split('.')
      const extension = fileNameArr[fileNameArr.length - 1].toLowerCase()
      return this.allowedFileExtensions.includes(extension)
    },
    resetSelectedImage() {
      if (this.selectedImage.path) {
        URL.revokeObjectURL(this.selectedImage.path)
      }
      this.selectedImage = {
        file: null,
        path: null
      }
    },
    // file select method ed

    // crop method st
    onChangeCropImage({coordinates, canvas}) {
      this.cropImage.coordinates = coordinates
      this.cropImage.path = canvas.toDataURL()
      canvas.toBlob(blob => {
        this.cropImage.file = new File([blob], this.selectedImage.file?.name, {
          type: this.selectedImage.file?.type,
          lastModified: Date.now()
        })
      })
    },
    resetCropImage() {
      if (this.cropImage.path) {
        URL.revokeObjectURL(this.cropImage.path)
      }
      this.cropImage = {
        coordinates: {},
        path: null,
        file: null
      }
    },
    onCancelCropImage() {
      this.cleanUpCropState()
    },
    onCompleteCropImage() {
      this.saveCropImageToEditProfile()
      this.cleanUpCropState()
    },
    saveCropImageToEditProfile() {
      this.editUserProfile.profileImageUrl = this.cropImage.path
      this.editUserProfile.file = this.cropImage.file
      this.editUserProfile.removeImage = false
    },
    cleanUpCropState() {
      this.resetSelectedImage()
      this.resetCropImage()
      this.isShowCropper = false
    },
    // crop method ed

    async onSaveUserProfile() {
      if(this.isLoadingChangeUserProfile){
        return;
      }
      this.isLoadingChangeUserProfile = true;
      const roomId = this.roomInfo?.roomId || this.camStudy.roomId;
      try {
        const { nickname, originProfileImagePath, file, profileImageUrl, removeImage } = this.editUserProfile;
        if (!nickname) {
          this.$camsAlert(this.$t('camstudy.preview.profile.nicknameError'));
          return;
        }
        const originNickname = this.userProfile.nickname;
        if (originNickname !== nickname) {
          await this.changeCamStudyUserNickname({
            roomId,
            nickname,
            sendEvent: !this.isDevicetest
          });
          if (this.isDevicetest) {
            this.$emit('onUpdateNickname', nickname)
          }
        }

        const profileImageData = {
          roomId,
          originImagePath: originProfileImagePath,
          removeImage,
          sendEvent: !this.isDevicetest,
        };

        let newProfileImagePath
        if (removeImage) {
          newProfileImagePath = (await this.changeProfileImage(profileImageData)).data.profileImagePath;
        } else if (file) {
          const tempImagePath = await this.uploadProfileImageFile(file);
          profileImageData.tempImagePath = tempImagePath;
          newProfileImagePath = (await this.changeProfileImage(profileImageData)).data.profileImagePath;
        }
        Object.assign(this.userProfile, { nickname, profileImageUrl, profileImagePath: newProfileImagePath || '' });
        this.$camsAlert(this.$t('camstudy.preview.profile.saveSuccess'));
        this.onCloseDepsContainer();
      } catch (e) {
        console.error('## onSaveUserProfile error -> reason[%s]', e);
        this.$camsAlert(this.$t('camstudy.preview.profile.saveFail'));
      }finally {
        this.isLoadingChangeUserProfile = false;
      }
    },
    cleanUpEditUserProfile() {
      this.editUserProfile = {
        nickname: '',
        profileImageUrl: '',
        originProfileImagePath: '',
        file: null,
        removeImage: false
      }
    },
    toggleTransitionCamera(boolean){
      this.selectedDevice.video.usePreviewMirror = boolean;
    },

    // video preview
    ...(function(){
      return {
        ...mapActions('call', [
          'getLocalDeviceSetting', 'saveLocalDeviceSetting',
          'getUserVideoStream', 'changeUserDevice'
        ]),
        async initVideoPreview () {
          await (async () => {
            const setting = await this.getLocalDeviceSetting();
            _.merge(this.selectedDevice.video, setting.video);
            _.merge(this.selectedDevice.audiooutput, setting.audiooutput);
          })();

          const devices = await this.getVideoDevices();
          this.SET_DEVICES(devices);

          if(devices.length === 0){
            this.selectedDevice.cameraStatus = 'notExist';
            return;
          }

          await this.previewVideo();
          this.initVideoBlur();
        },
        async saveVideoDevice () {
          const {selectedDevice} = this;
          const { video, audiooutput } = selectedDevice;
          this.saveLocalDeviceSetting({
            video, audiooutput
          });

          if(!this.isDevicetest){
            if(video.deviceId){
              await this.stopMediaStream();

              const currVideoTrack = await (async () => {
                if(this.isDevicetest) return null;
                let stream = await this.getUserVideoStream({userId:'me'});
                if(!stream) return null;
                return stream.getVideoTracks()[0];
              })();
              const trackGen = currVideoTrack?.GrmTrackUtils()?.getTrackGenerator();
              trackGen?.setMirror(video.usePreviewMirror);
              if(!currVideoTrack
                || currVideoTrack.GrmTrackUtils().getDeviceId() !== video.deviceId){
                this.changeUserDevice({deviceType: 'video', deviceId: video.deviceId});
              }
            }
          }
        },
        async getVideoDevices () {
          const devices = await GrmWebRTC.getUserDevice();
          const videos = devices.videoinput.map(device => device.toJSON());
          if(videos.length === 0) return videos;

          if(!videos[0].label){
            try{
              const stream = await GrmWebRTC.getUserMedia({video: true});
              stream.getTracks().forEach(t => t.stop());
            }catch(e){
              console.error(e);
            }
          }
          return videos;
        },
        getPreviewVideoTrack () {
          // Canvas 렌더링 중이면 저장된 track 사용
          if (this.renderCanvas && this.currentGrmTrack) {
            return this.currentGrmTrack;
          }
          const video = this.$refs['preview_video'];
          return video?.srcObject?.getVideoTracks()[0];
        },
        async previewVideo (deviceId) {
          let device = await (async () => {
            const devices = await this.getVideoDevices();
            deviceId = deviceId || this.selectedDevice.video?.deviceId;
            let device = deviceId && devices.find(d => d.deviceId === deviceId);
            if(!device){
              device = devices[0];
            }
            return device;
          })();
          Object.assign(this.selectedDevice.video, device);

          const currVideoTrack = await (async () => {
            if(this.isDevicetest) return null;
            let stream = await this.getUserVideoStream({userId:'me'});
            if(!stream) return null;
            return stream.getVideoTracks()[0];
          })();

          const video = this.$refs.preview_video;
          let track;
          if(!video){
            track = this.getPreviewVideoTrack();
          }else {
            track = video.srcObject?.getVideoTracks()[0];
          }
          if(track){
            track.GrmTrack.getDeviceId()
            if(track.GrmTrack.getDeviceId() === device.deviceId){
              return;
            }

            if(!track.GrmTrackUtils().equalsOriTrackDeviceId(currVideoTrack)){
              track.GrmTrackUtils().getOriTrack().stop();
            }
          }

          const newTrack = await (async () => {
            const stream = await (async () => {
              if(currVideoTrack){
                if(
                    !deviceId
                    || currVideoTrack.GrmTrackUtils().getDeviceId() === device.deviceId
                ){
                  return new MediaStream([currVideoTrack.GrmTrackUtils().getOriTrack()]);
                }
              }

              const config = {
                video: device.deviceId ? {
                  deviceId: {exact: device.deviceId},
                  width: {ideal: 640},
                  height: {ideal: 360},
                } : true
              };
              try{
                const stream = await GrmWebRTC.getUserMedia(config);
                return stream;
              }catch(e){
                console.error('getUserMedia err:', JSON.stringify(config), e);
              }
            })();

            return stream.getVideoTracks()[0];
          })();

          if(!track){
            track = await newTrack.convertToGrmTrack({
              stream: new MediaStream([newTrack])
            }, {type: 'canvasWorker'});
            await track.GrmTrack.getTrackGenerator().pipeThrough('BlurFilter', {direction: 'top-down'})
            track.GrmTrack.getTrackGenerator().resize(180, 180, 'crop');

            // GrmTrack 저장 (Canvas 렌더링 시 필요)
            this.currentGrmTrack = track;
            
            // Canvas 기반 렌더링 시도 (iOS 호환성)
            const canvas = track.GrmTrack.getTrackGenerator().getRenderCanvas();
            if(canvas && (this.isIOS || this.isSafari)) {
              this.renderCanvas = canvas;
              this.setupCanvasRender(canvas);
            } else {
              this.renderCanvas = null;
              const stream = video.srcObject || new MediaStream();
              stream.addTrack(track);
              // iOS 호환성을 위해 GrmWebRTC.attachMediaStream 사용
              GrmWebRTC.attachMediaStream(video, stream);
              this.playVideoWithErrorHandling(video);
            }
          }else{
            this.currentGrmTrack = track;
            track.GrmTrack.getTrackGenerator().replaceVideoMediaStreamTrack(newTrack);
            this.playVideoWithErrorHandling(video);
          }
        },
        // 에러 처리가 개선된 비디오 재생 (RoomCallCamstudyP2PVideo 방식 참고)
        async playVideoWithErrorHandling(video) {
          if (!video) return;

          function checkError(e) {
            if (e.message.includes('aborted')) {
              // 자동 재생 문제
              if (!video.muted) {
                console.error('Video autoplay failed - video not muted');
                return;
              }
              console.warn('Video autoplay aborted (normal for iOS)');
            } else if (e.message.includes('interrupted by')) {
              // 정상적인 중단 - 무시
              console.log('Video play interrupted (normal)');
            } else {
              console.error('Video play error:', e);
            }
          }

          try {
            await video.play();
            console.log('Video play successful');
          } catch (error) {
            checkError(error);
          }
        },
        // Canvas 렌더링 설정 (RoomVideo 방식 참고)
        setupCanvasRender(canvas) {
          this.$nextTick(() => {
            const canvasLayer = this.$refs.canvasRenderLayer;
            if (!canvasLayer) return;

            // 기존 canvas 제거
            const oldCanvas = canvasLayer.querySelector('canvas');
            if (oldCanvas) {
              oldCanvas.replaceWith(canvas);
            } else {
              // Canvas 스타일 설정
              Object.assign(canvas.style, {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '12px'
              });
              canvasLayer.appendChild(canvas);
            }
            console.log('Canvas rendering enabled for iOS compatibility');

            // Canvas 렌더링 모드에서 Face detection 초기화
            setTimeout(async () => {
              await this.getPersonalSetting();
              const track = this.getPreviewVideoTrack();
              const trackApp = track?._grm_tg;
              if(!trackApp) return;

              try {
                if(this.personalSetting.coverFace === 'off'){
                  trackApp.setFaceDrawType(null);
                }else{
                  const faceImage = require(`@/assets/roomType/lms/img/emoti-img/grm-face-01.svg`);
                  await trackApp.pipeThrough('FaceDetector', {
                    drawType: 'faceImage',
                    faceImage,
                  });
                  await trackApp.setFaceImage(faceImage);
                }
              } catch (error) {
                console.error('Face detection initialization failed:', error);
                console.warn('Face detection disabled due to browser compatibility issues');
              }
            }, 200);
            this.initCanvas()
          });
        },
        async toggleCamera (selectedDeviceId) {
          // if(this.cameraOff) {
          //   return
          // }
          const video = this.$refs['preview_video'];
          let currentVideoId = (() => {
            let deviceId = this.selectedDevice.video?.deviceId;
            if(deviceId) return deviceId;
            return video.srcObject?.getVideoTracks()[0]?.GrmTrack.getDeviceId();
          })();

          let currentDeviceIndex = -1;

          let devices = await this.getVideoDevices();
          const videos = devices
              .reduce((data, device, idx) => {
                data.list.push(device);
                if(device.deviceId === currentVideoId){
                  currentDeviceIndex = idx;
                }
                let label = device.label.toLowerCase();
                if(
                    label.includes('전면') || label.includes('front')
                ){
                  data.front.push(device);
                }else if(
                    label.includes('후면') || label.includes('back')
                ){
                  data.back.push(device);
                }
                return data;
              }, {
                front: [], back: [], list: []
              });

          let changeDevice;
          if(videos.front.length > 0 && videos.back.length > 0){
            [videos.front, videos.back].forEach(arr => {
              arr.sort((a,b) => a.label.localeCompare(b.label));
            });
            if (currentVideoId === videos.front[0].deviceId) {
              changeDevice = videos.back[0];
            } else {
              changeDevice = videos.front[0];
            }
          }else{
            let idx = currentDeviceIndex + 1;
            if(idx+1 >= videos.list.length){
              idx = 0;
            }
            changeDevice = videos.list[idx];
          }
          if(!changeDevice) return;
          if(changeDevice.deviceId === currentVideoId) return;
          const {deviceId} = changeDevice;
          this.previewVideo(deviceId);
        },
        async stopMediaStream(){
          let track = this.getPreviewVideoTrack();
          if(!track) return;

          if(!this.isDevicetest){
            const currVideoTrack = await (async () => {
              if(this.isDevicetest) return null;
              let stream = await this.getUserVideoStream({userId:'me'});
              if(!stream) return null;
              return stream.getVideoTracks()[0];
            })();
            if(track.GrmTrackUtils().equalsOriTrackDeviceId(currVideoTrack)){
              track.GrmTrack.getTrackGenerator().destroy();
              return;
            }
          }
          track.GrmTrack.getOriTrack().stop();
          track.GrmTrack.getTrackGenerator().destroy();
        },
      }
    }()),
    // video blur
    ...(function(){
      return {
        ...mapActions('camstudy', ['getVideoBlurOptions', 'changeVideoBlur']),
        async initVideoBlur () {
          const options = await this.getVideoBlurOptions();

          if(!options || options.percent <= 0 || options.blurSize <= 0){
            return;
          }

          let {percent, blurSize} = options;
          this.blurVideo.initBlurOptions = {
            height: percent * 100,
            blurSize
          };
          Object.assign(this.blurVideo, this.blurVideo.initBlurOptions);
          this.setBlurVideo();
          // const track = this.getPreviewVideoTrack();
          // track?.GrmTrack?.setPipeOptions('BlurFilter', {
          //   percent, blurSize
          // });

          // const el = this.$refs.videoBlurControl;
          // const initValue = {
          //   maxWidth: el.parentElement.offsetWidth,
          //   maxHeight: el.parentElement.offsetHeight,
          // }
          // let left = initValue.maxWidth * (blurSize / 15);
          // let top = initValue.maxHeight * percent;
          // Object.assign(el.style, {
          //   left: `${left}px`,
          //   top: `${top}px`,
          // });
        },
        onClickBlurFilterButton (e) {
          e.preventDefault();

          const el = e.target;
          const style = getComputedStyle(el);
          const initValue = {
            maxWidth: el.parentElement.offsetWidth,
            maxHeight: el.parentElement.offsetHeight,

            startLeft: parseInt(style.left) || 0,
            startTop: parseInt(style.top) || 0,

            startX: e.clientX ?? e.touches?.[0]?.clientX,
            startY: e.clientY ?? e.touches?.[0]?.clientY,
          };

          let blurOptions;

          const moveListener = e => {
            e.preventDefault();
            e.stopPropagation();

            const clientX = e.clientX ?? e.touches?.[0]?.clientX;
            const clientY = e.clientY ?? e.touches?.[0]?.clientY;
            if (clientX == null || clientY == null) return;

            let gapX = e.clientX - initValue.startX;
            let gapY = e.clientY - initValue.startY;

            let left = Math.max(initValue.startLeft + gapX, 0);
            if(left > initValue.maxWidth){
              left = initValue.maxWidth;
            }
            el.style.left = `${left}px`;

            let top = Math.max(initValue.startTop + gapY, 0);
            if(top > initValue.maxHeight){
              top = initValue.maxHeight;
            }
            el.style.top = `${top}px`;

            let blurSize = left / initValue.maxWidth;
            blurSize = parseInt(blurSize * 15);

            let percent = top / initValue.maxHeight;
            if(percent <= 0.05){
              percent = 0;
            }
            blurOptions = {
              percent: Math.max(percent, 0),
              blurSize
            };

            const track = this.getPreviewVideoTrack();
            track.GrmTrack.setPipeOptions('BlurFilter', blurOptions);
          };

          const upListener = e => {
            if(blurOptions){
              this.changeVideoBlur({...blurOptions});
            }
            el.releasePointerCapture(e.pointerId);
            el.removeEventListener('pointermove', moveListener);
            el.removeEventListener('pointerup', upListener);
            el.removeEventListener('pointercancel', upListener);
          };

          el.setPointerCapture(e.pointerId);
          el.addEventListener('pointermove', moveListener, false);
          el.addEventListener('pointerup', upListener, {once: true});
          el.addEventListener('pointercancel', upListener, {once: true});
        },
        toggleBlurVideo () {
          if (!this.isBlurEnabled) {
            this.$camsAlert({
              text: '해당 기능은 프리미엄 스터디에서만 사용하실 수 있습니다.',
              onlyOk: true
            });
            return
          }

          this.blurVideo.isOpen = !this.blurVideo.isOpen;
          if(this.blurVideo.isOpen){
            this.initVideoBlur();
          }
        },
        cancelBlurVideo () {
          this.blurVideo.isOpen = false;
          Object.assign(this.blurVideo, this.blurVideo.initBlurOptions);
          this.setBlurVideo();
        },
        setBlurVideo () {
          const {height, blurSize, blurMaxSize} = this.blurVideo;

          const blurOptions = {
            percent: Math.max(height / 100, 0),
            blurSize
          };

          const track = this.getPreviewVideoTrack();
          if (!track || !track.GrmTrack) {
            console.warn('No GrmTrack available for blur filter');
            return;
          }

          try {
            track.GrmTrack.setPipeOptions('BlurFilter', blurOptions);
            this.changeVideoBlur(blurOptions);
          } catch (error) {
            console.error('Failed to set blur options:', error);
          }
        },
        saveBlurVideo () {
          this.blurVideo.isOpen = false;
          const {height, blurSize} = this.blurVideo;
          this.changeVideoBlur({
            percent: Math.max(height / 100, 0),
            blurSize
          });
        },
        clearBlurVideo () {
          this.blurVideo.isOpen = false;
          this.changeVideoBlur({
            percent: 0,
            blurSize: 0
          });
        },
      }
    }()),
  }
}
</script>

<style lang="scss" scoped>
.device-setting-preview-component {
  background: #1F1F1F;
  line-height: 1.5;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}

.device-setting-preview {
  height: 100%;
  line-height: 1.5;
}

.device-set-preview {
  //width: 400px;
  height: 100%;
  //padding: 32px 44px;
  position: relative;
}

.device-set-preview-header {
  height: 50px;

  &.screenSetting {
    padding: 6px 16px;
    height: 44px;

    .device-set-preview-title-wrapper{
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;

      .close-btn{
        position: absolute;
        top: 6px;
        left: calc(10px + env(safe-area-inset-left));
        width: 32px;
        height: 32px;
        background-size: auto 24px;
      }

      .save-content{
        position: absolute;
        top: 6px;
        right: calc(10px + env(safe-area-inset-right));
        padding: 0 4px;
        height: 32px;
        font-weight: 700;
      }
    }
  }
}

.device-set-preview-title-wrapper {
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: white;
}

.device-set-preview-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  line-height: 22px;
}
.device-set-preview-video-container {
  position: relative;
}
.device-set-preview-video-wrapper {
  //width: 100%;
  aspect-ratio: 1 / 1;

  &.profile-modify{
    display: flex;
    width: 100%;
    padding: 16px;
    flex-direction: column;
    border-radius: 12px;
    &.flex-start{
      justify-content: flex-start !important;
    }
    align-items: center;
    aspect-ratio: 1/1;
    background: linear-gradient(180deg, #121212 0%, #313131 100%);
    gap: 24px;
    .profile-button-container{
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 40px);
    }
    .profile-button{
      border-radius: 10px;
      background: #1F1F1F;
      width: 100%;
      padding: 12px;

      &.cancel{
        color: #999;
        font-size: 14px;
        font-weight: 400;
        line-height: 150%;
      }
      &.save{
        color: #FFF;
        font-size: 14px;
        font-weight: 700;
        line-height: 150%;
      }
    }
    .profile-modify-input-container{
      border-bottom: 1px solid rgba(255, 255, 255, 0.20);
      display: flex;
      padding-bottom: 8px;
      justify-content: center;
      align-items: flex-end;
      gap: 2px;
      width: 100%;
      .profile-name-temp{
        width: 16px;
        height: 16px;
      }
      .profile-name-input{
        color: #FFF;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        line-height: 140%;
        background: transparent;
        outline: transparent;
        width: 100%;
      }
      .profile-name-change-icon{
        width: 16px;
        height: 16px;
        background: url("~@/assets/images/camstudy/ico_modify_white.svg") no-repeat center center;
      }
    }
  }
}

.device-set-preview-video-wrapper {
  .arrow-button1 {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: 2;
    touch-action: none;
    opacity: 0.7;

    &:active {
      //background: #c4c4c4;
      opacity: 1;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      transform: translateX(-50%);
    }

    &::before {
      top: 28%;
      border-bottom: 6px solid black;
    }
    &::after {
      bottom: 28%;
      border-top: 6px solid black;
    }
  }
  .arrow-button {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    cursor: grab;
    z-index: 2;
    opacity: 0.7;
    touch-action: none;

    &:active {
      opacity: 1;
      cursor: grabbing;
    }

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      pointer-events: none;
    }
  }

}

.device-set-preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  &.mirror {
    transform: scaleX(-1);
  }
}
.device-set-preview-status {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.device-set-preview-status-header {
  position: absolute;
  top:0;
  right: 0;
  left: 0;
}
.device-set-preview-status-warning-wrapper {
  padding: 7px 19px;
  background-color: #fb3030;
}
.device-set-preview-status-warning {
  font-size: 11px;
  color: #fff;
  line-height: 15px;
  text-align: center;
}
.device-set-preview-status-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}
.device-set-preview-status-controls {
  padding-bottom: 12px;
  display: flex;
  justify-content: center;
}
.device-set-preview-status-control {
  width: 32px;
  height: 32px;
  margin-left: 12px;
  border-radius: 100%;
  pointer-events: none;
  &:first-of-type {
    margin-left: 0;
  }
  &.mic {
    background: rgba(0, 0, 0, 0.6) url('~@/assets/images/mic_on_white.svg') no-repeat center / 16px auto;

    &.off {
      background: rgba(0, 0, 0, 0.6) url('~@/assets/images/mic_off_red.svg') no-repeat center / 16px auto;
    }
  }
  &.camera {
    background: rgba(0, 0, 0, 0.6) url('~@/assets/images/cam_on_white.svg') no-repeat center / 16px auto;

    &.off {
      background: rgba(0, 0, 0, 0.6) url('~@/assets/images/cam_off_red.svg') no-repeat center / 16px auto;
    }
  }
}
.device-set-preview-options-container {
  margin-top: 8px;
}
.device-set-preview-options-header {}
.device-set-preview-options-tabs {
  display: flex;
  position: relative;
  &::after {
    content: '';
    width: 50%;
    height: 3px;
    background-color: #59f;
    position: absolute;
    right: 0;
    bottom: 0;
    transition: 0.1s ease-out;
  }
  &.video { &::after { left: 0 } }
  &.audio { &::after { left: 50% } }
}
.device-set-preview-options-tab-btn {
  flex: 1;
  line-height: 48px;
  font-size: 13px;
  font-weight: 700;
  color: #333;
  text-align: center;
  position: relative;
  &::before {
    content: '';
    width: 100%;
    height: 1px;
    background-color: #f4f4f4;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
.device-set-preview-options-body {
  margin-top: 20px;
}
.device-set-preview-footer {
  position: absolute;
  right: 44px;
  bottom: 32px;
  left: 44px;
}
.device-set-preview-help-container {
  margin-top: 15px;
  display: flex;
}
.device-set-preview-help-text {
  font-size: 12px;
  color: #666;
}
.device-set-preview-help-link {
  margin-left: 8px;
  font-size: 12px;
  color: #267dff;
  text-decoration: underline;
  &:hover {
    color: #59f !important;
  }
}
.device-set-preview-option-section {
  margin-top: 36px;
  position: relative;
  &:first-of-type {
    margin-top: 0;
  }
}
.device-set-preview-option-mic-speaker-test-btn-wrapper {
  text-align: center;
}
.device-set-preview-option-mic-speaker-test-btn {
  padding: 0 12px;
  border-radius: 30px;
  background-color: #f0f6ff;
  font-size: 12px;
  color: #247bff;
  line-height: 35px;
  transition: 0.2s ease-out;
  &:hover {
    background-color: #bdd7ff;
  }
}
.device-set-preview-option-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 19px;
  display: flex;
  align-items: center;
}
.device-set-preview-option-beta {
  margin-left: 4px;
  display: flex;
  align-items: center;
}
.device-set-preview-option-description {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
  line-height: 16px;
}
.device-set-preview-option-body {
  margin-top: 12px;
}
.device-set-preview-option-video-mirror-container {
  margin-top: 12px;
}
.device-set-preview-option-virtual-background-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}
.device-set-preview-option-virtual-background-btn-wrapper {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  opacity: 0.8;
  transition: opacity 0.1s ease-out;
  &:hover,
  &.selected {
    opacity: 1;
  }
}

.device-set-preview-option-virtual-background-btn {
  height: 50px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  opacity: 0.8;
  transition: 0.1s ease-out;
  &::after {
    content: '';
    border: 3px solid #59f;
    padding-top: calc(25% - 3px);
    padding-bottom: calc(25% - 3px);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    transition: 0.1s ease-out;
  }
  &.none {
    background: #898989 url('~@/assets/images/no_use_white.svg') no-repeat center / 22px auto;
  }
  &.blur {
    background: url('https://biz-cdn.gooroomee.com/files/web/images/vbg/thumb_virtual_background_blur.png') no-repeat center / cover;
  }
  @for $i from 1 to 5 {
    &.inside_0#{$i} {
      background: url('https://biz-cdn.gooroomee.com/files/web/images/vbg/thumb_virtual_background_inside_0#{$i}.png') no-repeat center / cover;
    }
  }
  @for $i from 1 to 3 {
    &.outside_0#{$i} {
      background: url('https://biz-cdn.gooroomee.com/files/web/images/vbg/thumb_virtual_background_outside_0#{$i}.png') no-repeat center / cover;
    }
  }
  &.custom {
    height: 100%;
    background-color: #f1f1f1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &::before {
      content: '';
      width: 12px;
      height: 12px;
      background: url('~@/assets/images/plus.svg') no-repeat center / 12px auto;
      position: absolute;
      opacity: 0.4;
    }
    &:hover {
      background-color: #E4E4E4;
    }
  }
  &.change {
    height: auto;
    border-radius: 4px;
    padding: 0 4px;
    background: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    line-height: 24px;
    position: absolute;
    right: 5px;
    bottom: 5px;
    cursor: pointer;
  }
  &.apply {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  &.selected {
    opacity: 1;
    &::after {
      opacity: 1;
      visibility: visible;
    }
  }
  &.hide {
    display: none;
  }
  &:hover {
    opacity: 1;
  }
}
.device-set-preview-option-disabled-wrapper {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
}
.device-set-preview-option-disabled-text {
  font-size: 14px;
  color: #666;
  line-height: 22px;
  text-align: center;
  white-space: pre-line;
}
.device-set-preview-option-mic-volume-wrapper {
  height: 16px;
  margin-top: 10px;
  padding-left: 24px;
  background: url('~@/assets/images/mic_on_blue.svg') no-repeat center left / 14px auto;
  display: flex;
  align-items: center;
}
.device-set-preview-option-mic-volume {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #ededed;
}
.device-set-preview-option-mic-volume-fill {
  width: 100%;
  height: 100%;
  background-color: #59f;
  transform: scaleX(0);
  transform-origin: center left;
  transition: 0.1s ease-out;
}
.device-set-preview-option-deep-hearing-container {
  margin-top: 10px;
}

// Form
.form-select {
  width: 100%;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 0 26px 0 8px;
  background: white url('~@/assets/images/arrow_down_triangular_filled.svg') no-repeat center right 8px / 8px auto;
  font-size: 13px;
  font-weight: 500;
  color: #4b4b4b;
  line-height: 34px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  appearance: none;
  cursor: pointer;
}

// Toggle
.toggle-btn-container {
  .toggle-btn {
    display: none;
    &:checked {
      & + .toggle-label {
        .toggle-status {
          background-color: #59f;
          &::before {
            left: calc(100% - 16.5px);
          }
        }
      }
    }
  }
  .toggle-label {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
    .toggle-info {
      display: flex;
      align-items: center;
    }
    .toggle-label-text {
      font-size: 12px;
      font-weight: 400;
      color: #6a6a6a;
      &.deep-hearing {
        display: flex;
        align-items: center;
        &::after {
          content: '';
          width: 48px;
          height: 24px;
          margin-left: 8px;
          background: url('~@/assets/images/logo/deepHearing.png') no-repeat center / 100% auto;
          display: block;
        }
      }
    }
    .toggle-status {
      width: 36px;
      height: 18px;
      border-radius: 18px;
      background-color: #c4c4c4;
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      pointer-events: auto;
      transition: 0.2s ease-out;
      &.disabled {
        opacity: 0.5;
      }
      &::before {
        content: '';
        width: 15px;
        height: 15px;
        border-radius: 100%;
        background-color: #fff;
        position: absolute;
        left: 1.5px;
        transition: 0.2s ease-out;
      }
    }
  }
}

// Description
.description-container {
  margin-left: 6px;
  .description-btn {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: #f1f1f1;
    font-size: 12px;
    font-weight: 700;
    color: #898989;
    cursor: auto;
    pointer-events: auto;
    &:hover {
      & + .description-modal {
        top: calc(100% + 2px);
        opacity: 1;
        visibility: visible;
      }
    }
  }
  .description-modal {
    border-radius: 4px;
    padding: 8px 10px;
    background-color: #333;
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s ease-out;
  }
  .description-text {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 16px;
  }
}

.device-set-preview-join-room-btn-wrapper {}

// Button
.default-btn {
  width: 100%;
  border-radius: 4px;
  background-color: $mainColor;
  font-size: 14px;
  font-weight: 700;
  color: $White;
  line-height: 52px;
  min-height: 52px;
  text-align: center;
  display: block;
  transition: 0.2s ease-out;
  &:hover {
    background-color: #1b59f6;
    color: $White !important;
    text-decoration: none !important;
  }
  &:focus {
    outline: none;
    color: $White !important;
    text-decoration: none !important;
  }
  &.home {
    display: none;
  }
}
html:not([grm-device-mobile]){
  .default-btn-previous{
    &.innerRoom{
      position: fixed !important;
      bottom: 0 !important;
    }
  }
}
.default-btn-previous{
  background-color: #393939 !important;
  width: 100%;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  color: $White;
  line-height: 52px;
  min-height: 52px;
  text-align: center;
  display: block;
  transition: 0.2s ease-out;
  &:hover {
    color: $White !important;
    text-decoration: none !important;
  }
  &:focus {
    outline: none;
    color: $White !important;
    text-decoration: none !important;
  }
  &.home {
    display: none;
  }
}
.back-btn {
  display: block;
  width: 50px;
  height: 50px;
  background: url('~@/assets/images/camstudy/ico_arrowLeft_white.svg') no-repeat center / auto 50%;
}
.close-btn {
  width: 50px;
  height: 50px;
  background: url('~@/assets/images/camstudy/ico_close_white.svg') no-repeat center;
}
.ico-help-white{
  width: 50px;
  height: 50px;
  background: url('~@/assets/images/camstudy/ico_help_white.svg') no-repeat center;
}

// Mobile
.mobile {
  display: none;
}

[grm-device-mobile] {
  .device-setting-preview-component {
    width: 100dvw;
  }
  .device-setting-preview {
    display: flex;
    flex-direction: column;
  }
  .device-set-preview-title-wrapper {
    display: flex;
    justify-content: space-between;
    &.profile-modify {
      justify-content: center;
    }
  }
  .device-set-preview {
    width: 100%;
    height: 100%;
    //margin: 60px 0 70px;
    //padding: 0 24px;
    overflow-y: auto;
  }
  .device-set-preview-header {
    //position: fixed;
    //top: 24px;
    //right: 24px;
    //left: 24px;
  }
  .device-set-preview-body {
    margin-top: 0;
  }
  .device-set-preview-option-virtual-background-btn {
    height: auto !important;
    padding-top: 25%;
    padding-bottom: 25%;
  }
  .device-set-preview-footer {
    background-color: #fff;
    position: fixed;
    right: 24px;
    left: 24px;
  }
  .device-set-preview-join-room-btn-wrapper {
    margin: 12px -44px -32px;
  }
  .mobile {
    min-width: auto !important;
    display: block;
  }
  .inRoom {
    .device-set-preview {
      //padding: 0 24px;
    }
  }
}

// inRoom
.inRoom {
  .device-set-preview {
    width: auto;
    //padding: 20px 30px 100px;
  }
  .device-set-preview-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .device-set-preview-footer {
    right: 30px;
    bottom: 30px;
    left: 30px;
  }
}

.profile-image{
  width: 96px;
  height: 96px;
  border-radius: 50%;
}

.user-image-none{
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: url("~@/assets/images/user_profile.svg") no-repeat center;
  background-size: auto 48px;

  &.profile-image-none{
    width: 96px;
    height: 96px;
    background-size: auto 96px;
  }
}

// audio test
.device-setting-audio-test-component {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
}

.save-content{
  display: flex;
  height: 50px;
  width: 50px;
  padding: 0 4px;
  justify-content: center;
  align-items: center;
  color: #2A8BFE;
}

.modify-profile-image{
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  padding: 2px;
  background: #FFF url("~@/assets/images/camstudy/ico_camera_black.svg") no-repeat center center;
}
.input-file{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  &::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
  }
}
/** coordi **/
.device-container{
  width: 100%;
  position: absolute;
  bottom: 0;
  padding-bottom: 16px;
  padding-top: 48px;
  left: 50%;
  transform: translateX(-50%);
  //padding: 0 77px;
  display: flex;
  justify-content: center;
  gap: 36px;
  pointer-events: none;
  > * {
    pointer-events: auto;
  }

  .modify-profile{
    position: absolute;
    bottom: 0;
    right: 0;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    padding: 2px;
    background: #FFF url("~@/assets/images/camstudy/ico_modify_black.svg") no-repeat center center;
  }
  .device-info-container{
    flex-shrink: 0;
  }

  .device-info-image {
    background: #141414;
    width: 48px;
    height: 48px;
    border-radius: 24px;
  }
  .device-info-image{
    &.camera{
      &.active {
        background: #141414 url('~@/assets/images/camstudy/control_camera.svg') no-repeat center center;
        background-size: auto 24px;
      }
      &.notExist {
        background: #141414 url('~@/assets/images/camstudy/control_camera_notExist.svg') no-repeat center center;
        background-size: auto 24px;
      }
      &.inactive{
        background: #141414 url('~@/assets/images/camstudy/control_camera_inactive.svg') no-repeat center center;
        background-size: auto 24px;
      }
    }
    &.transition{
      background: #141414 url('~@/assets/images/camstudy/ico_camera_transition.svg') no-repeat center center;
    }
    &.blurVideo{
      background: #141414 url('~@/assets/images/camstudy/ico_blur_video_white.svg') no-repeat center center;
    }
  }
  .device-info-message{
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    margin-top: 8px;
    text-align: center;
    text-wrap: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 70px;
  }
}

@media (orientation: portrait) {
  .device-set-preview-video-container {
    margin: 0 auto;
  }
  .coordi-options-container {
    display: flex;
    align-items: center;
    justify-content: space-between;    
    margin: 20px 0;
    padding: 2px;
    border-radius: 8px;
    background-color: #141414;

    button {
      width: 100%;
      height: 30px;
      font-size: 12px;
      color: #FFFFFF;

      &.isActive {
        background: #393939;
        border-radius: 6px;
      }
    }
  }
  .coordi-room-header {
    text-align: left;
    padding: 30px 30px 0;
  }
  .join-room-btn {
    width: 100%;
    height: 50px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 0;
    background: #016FF2;
    min-height: 44px;
    line-height: 50px;
  }
  .video-preview-stopwatch{
    position: absolute;
    top: 12px;
    right: 12px;

    width: 84px;
    height: 28px;
    border-radius: 6px;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .device-set-preview-video-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media (orientation: landscape) {
  .device-set-preview{
   //padding: 0 59px 34px;
    padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  }
  .device-set-preview-body{
    display: flex;
    gap: 20px;
  }
  .device-set-preview-video-container{
    margin: 0 0;
    flex-shrink: 0;
    height: 100%;
    aspect-ratio: 1 / 1;
    max-height: 408px;
    .device-set-preview-video-wrapper{
      height: 100%;
      //width: auto;
    }
  }
  .video-preview-stopwatch{
    position: absolute;
    top: 16px;
    right: 16px;

    width: 84px;
    height: 28px;
    border-radius: 6px;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .setting-container{
    width: 100%;
    position: relative;
    .join-room-btn {
      width: 100%;
      height: 50px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background: #016FF2;
      min-height: 44px;
      line-height: 50px;
    }
    .coordi-options-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 20px 0;
      padding: 2px;
      border-radius: 8px;
      background-color: #141414;

      button {
        width: 100%;
        height: 30px;
        font-size: 12px;
        color: #FFFFFF;

        &.isActive {
          background: #393939;
          border-radius: 6px;
        }
      }
    }
  }
}
.determination-message{
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9) url("~@/assets/images/camstudy/ico_determination_black.svg") center right 10px no-repeat;
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 4px 30px 4px 10px;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  @media(orientation: portrait) {
    max-width: 220px;
  }
  @media(orientation: landscape) {
    max-width: 150px;
  }
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
}
.determination-input-container{
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  background: #313131;
  width: 344px;
  &.isDeviceTest{
    width: 374px;
  }
  .determination-body{
    width: 100%;
    padding: 25px 20px 20px 20px;
    color: #FFF;
    .determination-title{
      text-align: center;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 16px;
    }
    .determination-input{
      height: 45px;
      padding: 12px;
      border-radius: 8px;
      border: 1px solid #393939;
      width: 100%;
      background: #141414;
      font-size: 14px;
      line-height: 150%;
    }
  }
  .determination-footer{
    border-top: 0.333px solid rgba(255, 255, 255, 0.20);
    width: 100%;
    display: flex;
    .determination-button{
      width: 100%;
      padding: 15px 0 14px 0;

      &.cancel{
        color: #999;
        font-size: 14px;
        line-height: 150%;
      }
      &.ok{
        color: #FFF;
        font-size: 14px;
        line-height: 150%;
        font-weight: 700;
      }
    }
  }
}
/****************** Mobile ******************/
html:not([grm-device-mobile]){
  .device-set-preview-video-container{
    width: 100%;
    max-width: 408px;
    max-height: 408px;
  }
  .device-setting-preview-component{
    width: 100%;
  }
  .device-set-preview-body {
    position: relative;
    height: auto;
  }
  .device-set-preview{
    padding: 36px;
  }
  .image-select-container{
    width: 360px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .device-setting-preview-component{
    &.inRoom{
      width: 100%;
      height: 100%;

      .device-set-preview{
        padding: 0 20px 20px;

        .device-set-preview-body{
          flex-direction: column;
        }
      }
      .image-select-container{
        width: calc(100% - 16px)
      }
    }
    &:not(.inRoom){
      border-radius: 24px;
      .join-room-btn{
        border-radius: 12px;
      }
    }
  }
}
[grm-device-mobile]{
  .device-setting-preview-component{
    height: 100dvh;
  }
  .device-set-preview-body {
    position: relative;
    height: calc(100% - 50px);
    padding: 0 10px 10px;
  }
  .device-setting-audio-test-component {
    left: 0;
  }
  .image-select-container{
    bottom: 8px;
    left: 8px;
    right: 8px;
  }
}
.v-bg {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  aspect-ratio: 1/1;
  left: 0;
  border-radius: 12px;

  &.no-user {
    background-color: #394050;
  }

  &.no-cam {
    background: #222;
  }
}
.off{
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: #000;
  border-radius: 12px;
}
.image-select-cover{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.50);
}
.image-select-container{
  border-radius: 12px;
  background: #313131;
  position: absolute;
  padding: 12px 0;

  display: flex;
  flex-direction: column;

  .image-select-button{
    padding: 12px 20px;
    color: #FFF;
    font-size: 14px;
    text-align: left;
  }
}
.cropper-container{
  border-radius: 10px;
  width: 100%;
  aspect-ratio: 3 / 2;
  padding: 36.5px 19px;

  .cropper{
    width: 100%;
    aspect-ratio: 3 / 2;
  }
}
.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #007bff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}
.blur-video-container{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .blur-weight{
    padding: 16px 16px 0;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .blur-height{
    position: absolute;
    left: calc(100% - 54px);
    top: 28px;
    right: -100%;
    transform-origin: bottom left;
    transform: rotate(90deg);
    width: calc(100% - 143px);
  }
  .blur-weight-progress-container{
    padding: 0 12px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.70);
    backdrop-filter: blur(10px);
    height: 36px;

    display: flex;
    align-items: center;
    gap: 12px;

    &.vertical {
      height: 36px;
      width: 100%;
      .progress-title{
        transform: rotate(-90deg);
      }
    }

    .progress-title {
      font-weight: bold;
      font-size: 12px;
      white-space: nowrap;
    }
    .custom-slider {
      -webkit-appearance: none;
      width: 100%;
      height: 4px;
      border-radius: 10px;
      background: #ccc;
      outline: none;
      position: relative;
    }

    .custom-slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 24px;
      height: 24px;
      background: white;
      border-radius: 50%;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      position: relative;
      z-index: 2;
    }

    .custom-slider::-moz-range-thumb {
      width: 24px;
      height: 24px;
      background: white;
      border-radius: 50%;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
      cursor: pointer;
    }

    .custom-slider::before {
      content: '';
      position: absolute;
      height: 100%;
      background: #2978f0;
      z-index: 1;
      left: 0;
      top: 0;
      width: var(--slider-progress, 60%);
      pointer-events: none;
    }
  }
  .blur-button-container {
    display: flex;
    width: 100%;
    position: absolute;
    gap: 10px;
    padding: 0 20px 20px;
    left: 0;
    bottom: 0;

    .blur-video-button {
      display: flex;
      padding: 12px;
      justify-content: center;
      align-items: center;
      line-height: 150%;
      font-size: 14px;
      border-radius: 10px;
      background: #1F1F1F;
      width: 100%;

      &.cancel {
        color: #999;
      }

      &.save {
        color: #FFF;
        font-weight: 700;
      }
    }
  }
}
.shadow-rectangle {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%);
  background-blend-mode: multiply;
}
</style>